import { Activity, BarChart2, Loader2 } from "lucide-react";

export function TVFYSection({ tvfyData, tvfyLoading, isDark, surface, text, textSec }) {
  if (!tvfyData && !tvfyLoading) return null;
  return (
    <section data-testid="tvfy-section">
      <h2 className="text-xl font-black mb-4 pb-2 border-b-2 border-black flex items-center gap-2" style={{ color: text, fontFamily: "Outfit, sans-serif" }}>
        <Activity className="w-5 h-5" style={{ color: "#FFC82E" }} />
        Live Parliamentary Data
        <span className="text-xs font-bold px-2 py-0.5 border border-black" style={{ backgroundColor: "#FFC82E", color: "#000" }}>
          theyvoteforyou.org.au
        </span>
      </h2>
      {tvfyLoading ? (
        <div className="flex items-center gap-2 py-4">
          <Loader2 className="w-4 h-4 animate-spin" style={{ color: "#FFC82E" }} />
          <span className="text-sm" style={{ color: textSec }}>Loading live data…</span>
        </div>
      ) : tvfyData && (
        <div className="space-y-4">
          <div className="border-2 border-black p-4" style={{ backgroundColor: surface, boxShadow: "3px 3px 0 #000" }} data-testid="tvfy-attendance">
            <div className="flex items-center gap-2 mb-3">
              <BarChart2 className="w-4 h-4" style={{ color: "#FFC82E" }} />
              <span className="text-sm font-black" style={{ color: text }}>Parliamentary Attendance</span>
            </div>
            <div className="flex items-end gap-6 mb-3">
              <div>
                <div className="text-4xl font-black" style={{ color: (tvfyData.attendance_pct || 0) >= 80 ? "#10B981" : (tvfyData.attendance_pct || 0) >= 60 ? "#F59E0B" : "#EF4444", fontFamily: "Outfit, sans-serif" }}>
                  {tvfyData.attendance_pct ?? "—"}%
                </div>
                <div className="text-xs font-bold mt-0.5" style={{ color: textSec }}>attendance rate</div>
              </div>
              <div className="flex gap-4 text-sm">
                <div>
                  <span className="font-black" style={{ color: text }}>{tvfyData.votes_attended?.toLocaleString()}</span>
                  <span className="text-xs ml-1" style={{ color: textSec }}>attended</span>
                </div>
                <div>
                  <span className="font-black" style={{ color: text }}>{tvfyData.votes_possible?.toLocaleString()}</span>
                  <span className="text-xs ml-1" style={{ color: textSec }}>possible</span>
                </div>
                {(tvfyData.rebellions || 0) > 0 && (
                  <div>
                    <span className="font-black" style={{ color: "#F59E0B" }}>{tvfyData.rebellions}</span>
                    <span className="text-xs ml-1" style={{ color: textSec }}>rebellions</span>
                  </div>
                )}
              </div>
            </div>
            <div className="h-3 border border-black overflow-hidden" style={{ backgroundColor: isDark ? "#0F172A" : "#F1F5F9" }}>
              <div className="h-full transition-all duration-700" style={{ width: `${tvfyData.attendance_pct || 0}%`, backgroundColor: (tvfyData.attendance_pct || 0) >= 80 ? "#10B981" : (tvfyData.attendance_pct || 0) >= 60 ? "#F59E0B" : "#EF4444" }} />
            </div>
          </div>

          {(tvfyData.policy_scores || []).length > 0 && (
            <div className="border-2 border-black p-4" style={{ backgroundColor: surface, boxShadow: "3px 3px 0 #000" }} data-testid="tvfy-policy-scores">
              <p className="text-sm font-black mb-3" style={{ color: text }}>Policy Positions — based on actual votes</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {(tvfyData.policy_scores || []).slice(0, 10).map((score) => {
                  const ag = parseFloat(score.agreement) || 0;
                  const color = ag >= 75 ? "#10B981" : ag >= 50 ? "#3B82F6" : ag >= 25 ? "#F59E0B" : "#EF4444";
                  const label = ag >= 75 ? "Strongly for" : ag >= 50 ? "Leans for" : ag >= 25 ? "Leans against" : "Strongly against";
                  return (
                    <div key={score.policy_id} className="flex items-start gap-2 p-2 border border-black text-xs" style={{ backgroundColor: isDark ? "#0F172A" : "#F8FAFC" }}>
                      <span className="flex-shrink-0 font-black px-1.5 py-0.5 border border-current text-xs" style={{ color }}>{Math.round(ag)}%</span>
                      <div className="flex-1 min-w-0">
                        <p className="font-bold capitalize" style={{ color: text }}>{score.policy_name}</p>
                        <p className="text-xs" style={{ color }}>{label}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
              <p className="text-xs mt-3" style={{ color: textSec }}>
                Source: <a href="https://theyvoteforyou.org.au" target="_blank" rel="noopener noreferrer" className="underline">theyvoteforyou.org.au</a> · Live data
              </p>
            </div>
          )}
        </div>
      )}
    </section>
  );
}
